import { cgiService } from "../../services/cgiService/cgiService";
import { pickSchema } from "../common/schemaUtil";
import cloneDeep from "lodash-es/cloneDeep";
import pick from "lodash-es/pick";
import { customApiPrefix } from "../templates/apis/custom";
import { hideProp } from "../../tools/hideProp";
import { BaseCollection } from "./BaseCollection";
import { printLog } from "../../tools/log";
import { getResultByResponse } from "../common/getResultByResponse";
/**
 * DB http 使用的数据源请求对象
 * @param template
 */
export function collectionConstructorFactory(template) {
  class CollectionConstructor extends BaseCollection {
    constructor(collectionData, options) {
      super(collectionData, options);
      this.init();
    }
    async copyEntity(oldData) {
      return cloneDeep(oldData);
    }
    /**
     * 请求数据 todo
     * @param cgiInfo
     * @param args
     */
    async collectionRequest(cgiName, cgiInfo, requestObj = {
      query: {},
      body: {},
      headers: {},
      params: {}
    }, requestOptions) {
      const request = requestOptions.raw ? requestObj : this.getRequest(cgiName, cgiInfo, requestObj);
      const {
        envId,
        projectId,
        pageId,
        internal,
        useOrInsteadOfIn
      } = this.options;
      const res = await cgiService.requestCgiWithMiddlewares({
        collection: this.collectionData,
        cgiInfo,
        collectionId: this.collectionData.collectionId,
        envId,
        projectId,
        pageId,
        request,
        cgiName,
        raw: requestOptions.raw,
        batchEnabled: requestOptions.batchEnabled,
        internal,
        useOrInsteadOfIn
      });
      return getResultByResponse(res);
    }
    // eslint-disable-next-line complexity
    getRequest(cgiName, cgiInfo, requestObj) {
      var _this$options$getDyna, _this$options, _this$template$apiTem, _dynamicParamValues$w;
      const request = cloneDeep(requestObj);
      const dynamicParamValues = (_this$options$getDyna = (_this$options = this.options).getDynamicParamValues) === null || _this$options$getDyna === void 0 ? void 0 : _this$options$getDyna.call(_this$options, cgiName);
      printLog(`数据源请求[${this.collectionData.collectionId}/${cgiName}] 动态参数:`, dynamicParamValues);
      const querySchema = pickSchema(cgiInfo.fixedQuerySchema, cgiInfo.querySchema);
      // 只保留用户调试时使用的query参数，避免用户接口的参数和模板参数冲突，而已没有进行修剪
      if (querySchema !== null && querySchema !== void 0 && querySchema.fields && request.query) {
        request.query = pick(request.query, querySchema.fields.map(item => item.id || ''));
      }
      // 把模板定义的字段，有一些字段实际用户没有使用到的，需要删除，  1、保留用户使用的模板字段 2、非模板字段全部保留
      const originBodySchema = pickSchema(cgiInfo.fixedBodySchema, cgiInfo.fixedBodySchema); // 取模板交集
      const bodyTemplate = (_this$template$apiTem = this.template.apiTemplates.find(item => item.name === cgiName)) === null || _this$template$apiTem === void 0 ? void 0 : _this$template$apiTem.request.body;
      let bodyFields = null;
      if ((originBodySchema === null || originBodySchema === void 0 ? void 0 : originBodySchema.type) === 'object' && (bodyTemplate === null || bodyTemplate === void 0 ? void 0 : bodyTemplate.type) === 'object') {
        var _originBodySchema$fie, _bodyTemplate$fields;
        const oMap = (((_originBodySchema$fie = originBodySchema.fields) === null || _originBodySchema$fie === void 0 ? void 0 : _originBodySchema$fie.filter(item => item.id).map(item => item.id)) || []).reduce((prev, item) => {
          prev[item] = true;
          return prev;
        }, {});
        bodyFields = ((_bodyTemplate$fields = bodyTemplate.fields) === null || _bodyTemplate$fields === void 0 ? void 0 : _bodyTemplate$fields.filter(item => item.id && !oMap[item.id])) || null; // 获取不被用户使用的模板字段
      }
      if (bodyFields) {
        bodyFields.filter(item => item.id).forEach(item => {
          delete request.body[item.id];
        });
      }
      if (dynamicParamValues !== null && dynamicParamValues !== void 0 && dynamicParamValues.query) {
        // 添加query动参
        request.query = {
          ...request.query,
          ...dynamicParamValues.query
        };
      }
      if (dynamicParamValues !== null && dynamicParamValues !== void 0 && dynamicParamValues.body) {
        request.body = {
          ...request.body,
          ...dynamicParamValues.body
        };
      }
      if (dynamicParamValues !== null && dynamicParamValues !== void 0 && (_dynamicParamValues$w = dynamicParamValues.wholeBody) !== null && _dynamicParamValues$w !== void 0 && _dynamicParamValues$w.wholeBody) {
        request.body = dynamicParamValues.wholeBody.wholeBody;
      }
      return request;
    }
    init() {
      const templateCgis = this.template.apiTemplates.map(item => item.name);
      const customCgis = Object.keys(this.collectionData.cgiInfo).filter(item => item.startsWith(customApiPrefix));
      const cgis = templateCgis.concat(customCgis);
      cgis.forEach(name => {
        hideProp(this, name, {
          async value(request, options = {
            raw: false
          }) {
            const cgiInfo = this.collectionData.cgiInfo[name];
            if (!cgiInfo) {
              throw new Error(`无法发起请求: 数据源接口 [${name}] 未配置`);
            }
            return await this.collectionRequest(name, cgiInfo, request, options);
          },
          configurable: true
        });
      });
    }
  }
  Object.defineProperty(CollectionConstructor.prototype, 'template', {
    get() {
      return template;
    },
    enumerable: false,
    configurable: false
  });
  return CollectionConstructor;
}
export function getSchemaByPath(responseSchema, path) {
  const schema = path.reduce((prev, item) => {
    if (!prev) {
      return null;
    }
    if (item.type === 'fields') {
      var _prev$fields;
      const target = ((_prev$fields = prev.fields) === null || _prev$fields === void 0 ? void 0 : _prev$fields.find(f => f.id === item.id)) || null;
      return target;
    }
    if (item.type === 'items' && prev.items) {
      return prev.items;
    }
    return null;
  }, responseSchema);
  return schema;
}
//# sourceMappingURL=collectionConstructorFactory.js.map
